"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var Settings = require("./settings");
var constants_1 = require("../data/constants");
var defaultHeader = function () {
    var token = Settings.get("token", {});
    var headers = {
        "Accept": "application/json",
        "Content-Type": "application/json",
    };
    if (token.platform_token) {
        headers["PlatformToken"] = token.platform_token;
    }
    if (token.access_token && token.token_type) {
        headers["Authorization"] = [
            token.token_type,
            token.access_token,
        ].join(" ");
    }
    return headers;
};
var extractPagination = function (result) {
    var headerValue = function (key) {
        var value = result.headers[key] || result.headers[key.toLowerCase()];
        return value && parseInt(value, 10);
    };
    if (!headerValue('X-Page')) {
        return null;
    }
    return {
        total: headerValue('X-Total'),
        totalPages: headerValue('X-Total-Pages'),
        page: headerValue('X-Page'),
        perPage: headerValue('X-Per-Page'),
        nextPage: headerValue('X-Next-Page'),
        prevPage: headerValue('X-Prev-Page'),
        offset: headerValue('X-Offset'),
    };
};
var request = function (url, method, data, headers) {
    if (data === void 0) { data = {}; }
    if (headers === void 0) { headers = {}; }
    if (!constants_1.endpoints.api) {
        throw new Error("Skiliko SKD not initialized");
    }
    var config = {
        url: url,
        method: method,
        headers: Object.assign({}, defaultHeader(), headers),
    };
    if (Object.keys(data).length > 0) {
        config[method === "get" ? "params" : "data"] = data;
    }
    return axios_1.default(config)
        .then(function (response) {
        var data = response.data;
        if (!data || !Array.isArray(data)) {
            return data;
        }
        data["pagination"] = extractPagination(response);
        return data;
    });
};
var sendGet = function (url, data, headers) {
    if (data === void 0) { data = {}; }
    if (headers === void 0) { headers = {}; }
    var dataToParams = Object.keys(data)
        .map(function (key) { return [key, data[key]].join("="); })
        .join("&");
    if (url.indexOf("?") <= 0) {
        url += "?";
    }
    url += dataToParams;
    return request(url, "get", {}, headers);
};
exports.sendGet = sendGet;
var sendPost = function (url, data, headers) {
    if (data === void 0) { data = {}; }
    if (headers === void 0) { headers = {}; }
    return request(url, "post", data, headers);
};
exports.sendPost = sendPost;
var sendPut = function (url, data, headers) {
    if (data === void 0) { data = {}; }
    if (headers === void 0) { headers = {}; }
    return request(url, "put", data, headers);
};
exports.sendPut = sendPut;
var sendDelete = function (url, data, headers) {
    if (data === void 0) { data = {}; }
    if (headers === void 0) { headers = {}; }
    return request(url, "delete", data, headers);
};
exports.sendDelete = sendDelete;
//# sourceMappingURL=_request-api.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/skiliko-sdk/lib/modules/_request-api.js
// module id = 762
// module chunks = 3